import { useMutation, useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from 'constants/endpoints';
import { get, handleError, handleResponse, post } from './base.service';

export const useGetSubscriptionsListQuery = (type: string) =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.SUBSCRIPTION_PLANS}/${type}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-subscription-plans'],
		refetchOnWindowFocus: false,
	});

export const useGetStripPaymentURLMutation = () =>
	useMutation({
		mutationFn: (payload: any) => {
			return post(API_ENDPOINTS.PAYMENT_URL, payload);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});

export const usePurchaseStatusQuery = (purchase_id: any) =>
	useQuery({
		queryFn: async () => {
			try {
				return await post(API_ENDPOINTS.CHECK_PURCHASE_STATUS, { purchase_id: purchase_id });
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['check-purchase-status'],
		refetchOnWindowFocus: false,
	});

export const usePurchaseHistoryQuery = (payload: any) =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.PURCHASE_HISTORY}?${payload?.paramsQuery}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-purchase-history'],
		enabled: !!payload?.type,
		refetchOnWindowFocus: false,
	});

export const useCheckSubscriptionQuery = (type: any) =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.CHECK_SUBSCRIPTION}?action=${type}`);
				return response;
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-check-subscription'],
		enabled: !!type,
		refetchOnWindowFocus: false,
	});

export const useGetCheckSubscriptionMutation = () =>
	useMutation({
		mutationFn: async (type: any) => {
			const response = await get(`${API_ENDPOINTS.CHECK_SUBSCRIPTION}?action=${type}`);
			return response;
		},
	});

export const useGetCancelSubscriptionMutation = () =>
	useMutation({
		mutationFn: (payload: any) => {
			return post(API_ENDPOINTS.CANCEL_SUBSCRIPTION, payload);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});
